import React, { useState, useRef, useEffect } from "react";
import { assets } from "../../../assets/assets";
import "./style/searchFilter.css";
import CaseUnit from "./caseUnit";
import { useFilterContext } from "../../../context/FilterContext";
import ar from "../../../lang/ar";
import en from "../../../lang/en";
import { useSearchParams } from "react-router-dom";
function SearchFilter({ onToggleMenu, mode = "default", lang }) {
  const {
    units,
    filters,
    setFilters,
    filteredUnits,
    setAvailabilityHiddenIdsSearch,
    inMasterFilter = false,
    searchText,
    setSearchText,
  } = useFilterContext();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const unitsCount = filteredUnits.length;
  const translations = lang === "ar" ? ar : en;
  const [searchParams, setSearchParams] = useSearchParams();
  const handleToggle = () => {
    if (!isOpen) {
      setIsOpen(true);
    }
  };

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      !event.target.closest(".side-menu-") &&
      !event.target.closest(".filter-overlay")
    ) {
      setIsOpen(false);
      if (inMasterFilter) {
      } else {
        onToggleMenu?.(false);
      }
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, inMasterFilter]);

  const handleShowResults = () => {
    if (onToggleMenu) {
      onToggleMenu(true);
    }
  };
  useEffect(() => {
    if (!isOpen) {
      onToggleMenu?.(false);
    }
  }, [isOpen, onToggleMenu]);
  const [isCaseUnitOpen, setIsCaseUnitOpen] = useState(false);

  // const handleReset = () => {
  //   setSearchText("");

  //   // 2. إعادة تعيين أرقام الغرف والحمامات والمساحة لقيم فارغة
  //   setFilters({
  //     ...filters,
  //     bedrooms: { min: "" },
  //     bathrooms: { min: "" },
  //     area: { min: "" },
  //   });
  //   setAvailabilityHiddenIdsSearch([]);

  //   //  قفل المنيو بعد الريسيت
  //   // setIsOpen(false);
  // };

  const handleReset = () => {
    setSearchText("");

    // حساب القيم العظمى من الـ units الموجودة حالياً
    const maxBedrooms =
      units.length > 0
        ? Math.max(...units.map((u) => u.num_of_bedrooms || 0))
        : "";
    const maxBathrooms =
      units.length > 0
        ? Math.max(...units.map((u) => u.num_of_bathrooms || 0))
        : "";
    const maxArea =
      units.length > 0
        ? Math.max(...units.map((u) => Number(u.built_up_area) || 0))
        : "";

    setFilters({
      ...filters,
      bedrooms: { min: "", max: maxBedrooms },
      bathrooms: { min: "", max: maxBathrooms },
      area: { min: "", max: maxArea },
    });

    setAvailabilityHiddenIdsSearch([]);

    //   //  قفل المنيو بعد الريسيت
    //   // setIsOpen(false);
  };
  return (
    <div
      className={`dropdown search-filter col-12 ${isOpen ? "show" : ""}`}
      ref={dropdownRef}
    >
      <div
        className="btn main-dropdown dropdown-toggle col-12"
        role="button"
        aria-expanded={isOpen}
        onClick={handleToggle}
      >
        <img src={assets.search} alt="Filter Icon" className="filter-icon" />
        {/* <input
          type="text"
          className="form-control"
          placeholder={translations.search}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          onFocus={() => setIsOpen(true)}
        /> */}
        <input
          type="text"
          className="form-control"
          placeholder={translations.search}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          onFocus={() => setIsOpen(true)}
          onKeyDown={(e) => {
            // التحقق من ضغط Enter وجود نتيجة واحدة فقط
            if (e.key === "Enter" && filteredUnits.length === 1) {
              const unitCode = filteredUnits[0].code;

              // 1. تحديث الرابط بكود الوحدة (هذا ما يحرك الماستر بلان)
              setSearchParams({ unit: unitCode }, { replace: true });

              // 2. إغلاق القوائم المنبثقة
              onToggleMenu?.(false);
              setIsOpen(false);
            }
          }}
        />
        <img
          src={assets.settingFilter}
          alt="Filter Icon"
          className="filter-icon mx-1"
        />
        <p className="count p-0 m-0 my-0">({unitsCount})</p>
      </div>

      {isOpen && (
        <div className="dropdown-menu view-all border-0 col-12 my-0 show position-absolute">
          <p className="filter-by p-0">{translations.filter}</p>
          {/* <CaseUnit
            onSelectionChange={(hiddenIds) =>
              setAvailabilityHiddenIdsSearch(hiddenIds)
            }
          /> */}
          <CaseUnit
            lang={lang}
            isOpen={isCaseUnitOpen}
            toggleOpen={() => setIsCaseUnitOpen(!isCaseUnitOpen)}
            onSelectionChange={(hiddenIds) =>
              setAvailabilityHiddenIdsSearch(hiddenIds)
            }
          />
          {/* Bedrooms */}
          <div className="filter-bedrooms col-12 mt-2">
            <p className="side-title-filter p-0">{translations.bedrooms}</p>
            <div className="filter-rooms">
              <div className="filter-room">
                <input
                  type="number"
                  value={filters.bedrooms.min}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      bedrooms: { ...filters.bedrooms, min: e.target.value },
                    })
                  }
                />
                <p className="p-0 m-0">{translations.min}</p>
              </div>
              <p className="col-auto text-center m-0 p-0 to">
                {translations.to}
              </p>
              <div className="filter-room">
                <input
                  type="number"
                  value={filters.bedrooms.max}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      bedrooms: { ...filters.bedrooms, max: e.target.value },
                    })
                  }
                />
                <p className="p-0 m-0">{translations.max}</p>
              </div>
            </div>
          </div>

          {/* Bathrooms */}
          <div className="filter-bedrooms col-12">
            <p className="side-title-filter p-0">{translations.bathrooms}</p>
            <div className="filter-rooms">
              <div className="filter-room">
                <input
                  type="number"
                  value={filters.bathrooms.min}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      bathrooms: { ...filters.bathrooms, min: e.target.value },
                    })
                  }
                />
                <p className="p-0 m-0">{translations.min}</p>
              </div>
              <p className="col-auto text-center m-0 p-0 to">
                {translations.to}
              </p>
              <div className="filter-room">
                <input
                  type="number"
                  value={filters.bathrooms.max}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      bathrooms: { ...filters.bathrooms, max: e.target.value },
                    })
                  }
                />
                <p className="p-0 m-0">{translations.max}</p>
              </div>
            </div>
          </div>

          {/* Area */}
          <div className="filter-bedrooms col-12">
            <p className="side-title-filter p-0">{translations.area}</p>
            <div className="filter-rooms">
              <div className="filter-room">
                <input
                  type="number"
                  value={filters.area.min}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      area: { ...filters.area, min: e.target.value },
                    })
                  }
                />
                <p className="p-0 m-0">{translations.min}</p>
              </div>
              <p className="col-auto text-center m-0 p-0 to">
                {translations.to}
              </p>
              <div className="filter-room">
                <input
                  type="number"
                  value={filters.area.max}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      area: { ...filters.area, max: e.target.value },
                    })
                  }
                />
                <p className="p-0 m-0">{translations.max}</p>
              </div>
            </div>
          </div>

          {/* Show results */}
          <div className="show-results-reset">
            <button className="reset-" type="button" onClick={handleReset}>
              Reset
            </button>
            <button className="spin-" type="button" onClick={handleShowResults}>
              {translations.showResult} ({unitsCount})
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchFilter;
